import { MenuProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppMenuItem } from "../../../../shared/components/AppMenu/AppMenuItem";
import { AppMenu } from "../../../../shared/components/AppMenu";
import { UploadFileButton } from "../../Buttons/UploadFileButton";
import { TEntityInfo } from "../../../types/utility";
import { AppButton } from "../../../../shared/components/AppButton";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { TMenuIds } from "../../../../app/state/menuSlice/types";
import { useMenuSelectors } from "../../../../app/state/menuSlice/hook/use-menu-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<MenuProps, "open"> {
  subtype: string;
  closeMenu: (id: TMenuIds, subtype: string) => void;
  handleUploadFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  openAttachedFileModal: (id: TModalsIds, info: TEntityInfo | null) => void;
  additionalOption?: React.ReactNode;
  multiple?: boolean;
  className?: string;
}

export const AttachedFileMenu = ({
  subtype,
  closeMenu,
  handleUploadFile,
  openAttachedFileModal,
  additionalOption,
  multiple,
  ...rest
}: Props) => {
  const attachedFileMenu = useMenuSelectors("attached_file_to_chat");
  const { t } = useTranslation();

  const titlePC = multiple ? t("common.upload_files") : t("common.upload_file");
  const titleArtifacts = multiple
    ? t("common.save_files_from_artifacts")
    : t("common.save_file_from_artifacts");

  return (
    <AppMenu
      open={attachedFileMenu.isOpen && attachedFileMenu.subtype === subtype}
      anchorReference={"anchorPosition"}
      anchorPosition={{
        left: (attachedFileMenu.position?.x ?? 0) + 35,
        top: attachedFileMenu.position?.y ?? 0,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      onClose={() => closeMenu("attached_file_to_chat", subtype)}
      {...rest}
    >
      <AppMenuItem className={styles["menu-item"]}>
        <UploadFileButton
          icon={null}
          type={"button"}
          multiple={multiple}
          handleFileUpload={handleUploadFile}
          title={titlePC}
          className={styles["menu-btn"]}
        />
      </AppMenuItem>
      <AppMenuItem className={styles["menu-item"]}>
        <AppButton
          buttonType="text"
          onClick={() => openAttachedFileModal("attached_file_modal", null)}
          className={styles["menu-btn"]}
        >
          {titleArtifacts}
        </AppButton>
      </AppMenuItem>
      {additionalOption && (
        <AppMenuItem
          onClick={() => closeMenu("attached_file_to_chat", subtype)}
          className={styles["menu-item"]}
        >
          {additionalOption}
        </AppMenuItem>
      )}
    </AppMenu>
  );
};
